export default __webpack_public_path__ + "static/desk-team-0c92a889740bee56414c097c7268c1f8.png";